import { parseServerInstant } from '../routes/Dashboard/core/mskTime'
import { MatchingPayoutHaltHold, MatchingPayoutTicket } from './_models'

export const HALT_UNDETERMINED_LABEL = 'Причина не определена'

const REASON_LABELS: Record<string, string> = {
  DISPUTE: 'Открыт диспут',
  FILES_VERIFICATION: 'Проверка файла',
  AWAITING_PAYMENT: 'Ожидание платежа',
  UNDETERMINED: HALT_UNDETERMINED_LABEL,
}

/** Reason text; a code this build does not know reads as undetermined. */
export const haltHoldReasonLabel = (reason: string): string =>
  REASON_LABELS[reason] ?? HALT_UNDETERMINED_LABEL

const formatReleaseTime = (raw: string): string =>
  parseServerInstant(raw).toLocaleTimeString('ru-RU', {
    timeZone: 'Europe/Moscow',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })

/** What has to happen for this deposit to stop holding the payout. */
export const haltHoldNeed = (hold: MatchingPayoutHaltHold): string => {
  switch (hold.reason) {
    case 'FILES_VERIFICATION':
      return 'Подтвердить или отклонить файл'
    case 'AWAITING_PAYMENT':
      return 'Дождаться истечения срока пополнения'
    case 'DISPUTE':
      return hold.releaseAt
        ? `Решить диспут · освободится сама около ${formatReleaseTime(hold.releaseAt)}`
        : 'Решить диспут · бессрочно'
    default:
      return '—'
  }
}

/** The payout is halted and still open, so the page owes an explanation. */
export const hasHaltExplanation = (ticket: MatchingPayoutTicket): boolean =>
  (ticket.haltHolds?.length ?? 0) > 0 || ticket.haltUndetermined === true
